import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Button from 'components/common/Button/Button'
import Text from 'components/common/Text/Text'
import Banner from 'components/common/Banner/Banner'
import { A } from 'components/common/Link/Link'
import { Separator } from 'components/common/Separator/Separator'
import Modal from 'components/common/Modal'
import Icon from 'components/common/Icon/Icon'
import Media from 'components/common/Media'

const AddressConfirmation = ({
  error,
  handleHide,
  handleUseEnteredAddress,
  handleUseVerifiedAddress,
  accountDetails: {
    address1 = '',
    city = '',
    state = '',
    zipCode = ''
  } = {},
  verifiedAddress: {
    address1: verifiedAddress1 = '',
    city: verifiedCity = '',
    state: verifiedState = '',
    zipCode: verifiedZipCode = ''
  } = {}
}) =>
  <ModalBox title="Address Confirmation" closeHandler={ handleHide }>
    {
      error ?
        <Fragment>
          <CustomBanner error_alternative>
            { error }
          </CustomBanner>
          <EditButton onClick={ handleHide }>Edit Your Address</EditButton>
        </Fragment> :
        <Fragment>
          <CustomText block bolder>Use USPS Verified Address:</CustomText>
          <AddressButton full onClick={ handleUseVerifiedAddress }>
            <AddressText>{ verifiedAddress1 }<br />
              { `${verifiedCity}, ${verifiedState} ${verifiedZipCode}` }
            </AddressText>
            <AddressIcon asset="address-confirm-arrow" />
          </AddressButton>
        </Fragment>
    }
    <CustomText block bolder>Or Use As Entered:</CustomText>
    <AddressButton full onClick={ handleUseEnteredAddress }>
      <AddressText>
        { address1 }<br />
        { `${city}, ${state} ${zipCode}` }
      </AddressText>
      <AddressIcon asset="address-confirm-arrow" />
    </AddressButton>
    {
      !error &&
      <Fragment>
        <SeparatingLine margin="10px 0 20px" />
        <EditLink anchor prevent handler={ handleHide }>
          <Icon asset="icon-edit" margin="-2px 10px 0 0" />Edit Your Address
        </EditLink>
      </Fragment>
    }
  </ModalBox>

AddressConfirmation.propTypes = {
  accountDetails: PropTypes.shape({
    address1: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.string
  }),
  error: PropTypes.string,
  handleHide: PropTypes.func,
  handleUseEnteredAddress: PropTypes.func,
  handleUseVerifiedAddress: PropTypes.func,
  verifiedAddress: PropTypes.shape({
    address1: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    postalCode: PropTypes.string,
    zipCode: PropTypes.string
  })
}

export default AddressConfirmation

const AddressText = styled.div`
  ${Media.mobile`
    padding-right: 35px;
  `}
`

const EditButton = styled(Button)`
  padding: 15px 24px 13px;
  margin-bottom: 25px;
`

const AddressButton = styled(Button)`
  position: relative;
  padding: 15px 24px;
  margin-bottom: 15px;
  text-align: left;
  text-transform: none;
`

const AddressIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
`

const ModalBox = styled(Modal)`
  padding: 25px 38px 25px 24px;
`

const CustomBanner = styled(Banner)`
  padding: 15px 30px 0;
`

const CustomText = styled(Text)`
  margin-bottom: 20px;
`

const SeparatingLine = styled(Separator)`
  margin: 15px 0 20px;
`

const EditLink = styled(A)`
  display: inline-block;
  margin-bottom: 12px;
`
